import React from "react";
import { CloneButton as RaCloneButton } from "react-admin";

const CloneButton = ({ record, ...props }) => {
	if (!record) {
		return null;
	}
	const { id, contest, created, modified, ...rest } = record;
	const newRecord = {
		...rest,
		name: `${rest.name} copy`,
	};
	return <RaCloneButton record={newRecord} {...props} />;
};
export default CloneButton;
